<script setup lang="ts">
import { useWinnersData } from '~/composables/useStates/useWinnersData';

const auth = useAuthStore();
const { $trackEvent } = useNuxtApp();
const { bigWinsLoading, loadMyBigWins, myBigWins } = useWinnersData();
watch(
  () => auth.loggedIn,
  (value) => {
    if (value) loadMyBigWins();
  },
);
</script>
<template>
  <div v-if="myBigWins.length > 0 || bigWinsLoading">
    <LazyWinnersSectionHeader
      v-if="myBigWins.length > 0"
      title="my-big-wins"
      alt="Big Winners"
      icon-name="celebrationIcon"
    >
      <template #header-actions-right>
        <DesignSystemButton
          type="secondary-alternative"
          rounding="md"
          padding="wide-short"
          @click="[
            auth.setAccountModalPage('my-big-wins'),
            $trackEvent('WinnersEvent', 'WINNERS_SEE_ALL_WINS'),
          ]"
        >
          <span class="text-sm capitalize">{{ $t('see-all') }}</span>
        </DesignSystemButton>
      </template>
    </LazyWinnersSectionHeader>
    <UserInterfaceGenericLoader v-if="bigWinsLoading" :standalone="true" />
    <div v-else-if="myBigWins.length > 0" class="sm:mx-0 sm:my-3">
      <LazyWinnersMyBigWinsCarousel
        v-if="myBigWins?.length > 0"
        :vertical-navigation="false"
        title-class="text-base"
        :display-title="false"
        :animate="false"
      />
    </div>
  </div>
</template>
